import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnnouncementService, BalanceQuery, MemberDetails, MemberQuery, config } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Observable } from 'rxjs';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  screenSize = ScreenType;
  productCode = ProductCode;

  pointsBalance$: Observable<number | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;

  showTopMenu: boolean = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    this.showTopMenu = scrollY > 210;
  }

  constructor(
    private announcementService: AnnouncementService,
    private balanceQuery: BalanceQuery,
    private memberQuery: MemberQuery,
    private router: Router
  ) {}

  ngOnInit() {
    this.announcementService.fetchAnnouncements().toPromise();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
  }

  navigateToWallet() {
    this.router.navigate(['/rewards/wallet']);
  }
}
